import { deselectAllChats, toggleChatListPending } from './actions';
import {
  fetchChatsBulkOperationsRestoreFromArchiveDesktop,
  TChatsBulkOperationsRestoreFromArchiveDesktopResponse,
} from '../../repositories/chats/v1/chats/bulk-operations/restore-from-archive-desktop';
import { showAlert } from '../../slices/alertSlice';
import { TThunkAction } from '../../types/redux/thunk';

/**
 * Восстановить чаты из архива
 * @param {string[]} chatIds массив id чатов
 */
export const restoreChatsFromArchive =
  (chatIds: string[]): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    dispatch(toggleChatListPending(true));

    try {
      const { statusCode, response }: TChatsBulkOperationsRestoreFromArchiveDesktopResponse =
        await fetchChatsBulkOperationsRestoreFromArchiveDesktop({
          httpApi,
          parameters: {
            chatIds,
          },
          config: { requestConfig: { withCredentials: true } },
        });

      if (statusCode === 200) {
        dispatch(deselectAllChats());
      } else {
        logger.warning('Код ответа не 200', {
          message: 'Не удалось восстановить из архива чаты',
          domain: 'src/shared/actions/chatList/restoreChatsFromArchive.ts',
          statusCode,
          messsage: response.message || 'Неизвестная ошибка',
          errors: JSON.stringify(response?.errors),
        });

        dispatch(showAlert({ message: 'Не удалось восстановить из архива чаты' }));
      }
    } catch (ex) {
      logger.error(ex, {
        message: 'Не удалось восстановить из архива чаты',
        domain: 'src/shared/actions/chatList/restoreChatsFromArchive.ts',
      });

      dispatch(showAlert({ message: 'Не удалось восстановить из архива чаты' }));
    } finally {
      dispatch(toggleChatListPending(false));
    }
  };
